/* TODO looks like this directive is never used, if that's the case we should remove this file and all its references */
;(function () {
  angular
    .module('contrast.vulnerabilities')
    .directive('csVulnerabilityTrace', csVulnerabilityTrace)

  function csVulnerabilityTrace() {
    return {
      restrict: 'E',
      controller: 'csVulnerabilityTraceCtrl',
      controllerAs: 'csVulnTraceCtrl',
      scope: {
        trace: '=',
        currentOrg: '=',
        href: '@',
        toggleSelection: '=',
        setVulnerabilityIndex: '=',
        index: '=',
        model: '='
      },
      templateUrl: 'components/vulnerabilities/cs-vulnerability-trace.html',
      link: function (scope, elem, attrs, ctrl) {
        ctrl.activate({
          trace: scope.trace,
          currentOrg: scope.currentOrg,
          href: scope.href,
          toggleSelection: scope.toggleSelection,
          setVulnerabilityIndex: scope.setVulnerabilityIndex,
          index: scope.index,
          model: scope.model
        })
      }
    }
  }
})()
